import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('feature-monetization', {
  library: 'feature-monetization'
});